export class Product{
  constructor(
    public ID:number,
    public name:string,
    private description:string,
    private buy_price:number,
    private unit_discount:number,
    private warehouse:number
  )
  {

  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/models/product.model.ts